// extracted by mini-css-extract-plugin
var _1 = "ConfirmFormStyle-module__back-btn___tyI2k";
var _2 = "ConfirmFormStyle-module__back-btn___tyI2k";
var _3 = "ConfirmFormStyle-module__buttons___IvOvr";
var _4 = "ConfirmFormStyle-module__cancel-btn___xCZSw";
var _5 = "ConfirmFormStyle-module__cancel-btn___xCZSw";
var _6 = "ConfirmFormStyle-module__confirm-form___ecjtp";
var _7 = "ConfirmFormStyle-module__confirm-form___ecjtp";
var _8 = "ConfirmFormStyle-module__headline___jgn3h";
var _9 = "ConfirmFormStyle-module__text___iIa_X";
export { _1 as "back-btn", _2 as "backBtn", _3 as "buttons", _4 as "cancel-btn", _5 as "cancelBtn", _6 as "confirm-form", _7 as "confirmForm", _8 as "headline", _9 as "text" }
